<template>
  <div
      ref="root"
      class="nine-grid"
      :style="{
      ...gridStyle,
      '--bg': background
    }"
  >
    <div class="cell tl"></div>
    <div class="cell tm"></div>
    <div class="cell tr"></div>

    <div class="cell cl"></div>
    <div class="cell cc"></div>
    <div class="cell cr"></div>

    <div class="cell bl"></div>
    <div class="cell bm"></div>
    <div class="cell br"></div>
  </div>
</template>

<script>
export default {
  name: "AngledNineGrid",

  props: {
    background: {
      type: String,
      default: "rgba(0,0,47,0.6)"
    },
    show: {
      type: Boolean,
      default: true
    },
    refreshCount: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      edgePx: 0
    };
  },

  watch: {
    show() {

      this.$nextTick(() => {
        this.updateGrid();
      });
    },
    refreshCount() {
      this.$nextTick(() => {
        this.updateGrid();
      });
    }
  },

  computed: {
    gridStyle() {
      const e = this.edgePx;
      if (!e) return {};

      return {
        display: "grid",
        width: "100%",
        height: "100%",
        gridTemplateRows: `${e}px ${e}px ${e}px`,
        gridTemplateColumns: `${e}px calc(100% - ${2 * e}px) ${e}px`
      };
    }
  },

  mounted() {
    this.updateGrid();
    window.addEventListener("resize", this.updateGrid);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.updateGrid);
  },

  methods: {
    updateGrid() {
      const root = this.$refs.root;
      if (!root) return;

      const parent = root.parentElement;
      const rect = parent.getBoundingClientRect();
      const h = rect.height;

      this.edgePx = Math.round(h / 3);
    }
  }
};
</script>

<style scoped>
.nine-grid {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.cell {
  position: relative;
  background: var(--bg);
}

.cc {
  background: var(--bg);
}

.tl {
  clip-path: polygon(0 100%, 105% 105%, 105% 0);
}

.br {
  clip-path: polygon(-5% -5%, -5% 100%, 100% -5%);
}

.tm,
.tr,
.cl,
.cr,
.bl,
.bm {
  background: var(--bg);
}
</style>
